export class LocalizacionModel {

  type: string;
  coordinates: number[];

  constructor() {
    this.type = '';
    this.coordinates = [];
  }
}
